import { render, staticRenderFns } from "./ScrollToLink.vue?vue&type=template&id=3a74aa39&"
import script from "./ScrollToLink.vue?vue&type=script&lang=js&"
export * from "./ScrollToLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./scripts/vue/ScrollToLink.vue
// module id = 199
// module chunks = 0